import { render, staticRenderFns } from "./SignatureSettings.vue?vue&type=template&id=65c8fb70&scoped=true"
import script from "./SignatureSettings.vue?vue&type=script&lang=js"
export * from "./SignatureSettings.vue?vue&type=script&lang=js"
import style0 from "./SignatureSettings.vue?vue&type=style&index=0&id=65c8fb70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c8fb70",
  null
  
)

export default component.exports